<script setup lang="ts">
defineProps<{
  color?: any
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <circle cx="17.5" cy="17.5" r="17.5" />
    <g>
      <g>
        <g>
          <g>
            <path
              fill="#FFFFFF"
              d="M7.726,7.463h19.804l0.017,19.716l0.004,0c0,0.248-0.064,0.55-0.269,0.755l-1.758,1.754l0.037-0.037
    c-1.051,0.843-6.089,2.709-14.324-5.331C2.565,15.846,4.425,10.379,5.404,9.44c0,0,1.686-1.717,1.689-1.712L7.1,7.723l0,0
    C7.284,7.54,7.515,7.457,7.742,7.463L7.726,7.463z M9.804,9.167c1.285,1.291,2.971,2.983,2.973,2.985
    c0.35,0.35,0.34,0.91-0.003,1.253l-1.713,1.702c-0.793,0.79-0.092,1.809,1.503,3.769c1.061,1.295,2.475,2.784,4.073,4.08
    c1.125,0.903,2.302,1.71,3.132,0.882l-0.045,0.042l1.748-1.753l0.01-0.002c0.367-0.367,0.928-0.329,1.262,0.007l0.007-0.005
    c0,0,1.749,1.756,3.074,3.087V9.168L9.804,9.167L9.804,9.167z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
